var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3"
  }, [_c('h5', [_vm._v("業務清單")]), _c('customer-staff-operator', {
    staticClass: "mb-3",
    attrs: {
      "filter": _vm.filter,
      "operator": _vm.operator,
      "boundTypes": _vm.boundTypes,
      "textMapping": _vm.textMapping
    },
    on: {
      "trigger-filter": function triggerFilter($event) {
        return _vm.getCustomerStaffs();
      },
      "trigger-change-staff": function triggerChangeStaff($event) {
        return _vm.showChangeStaff();
      },
      "trigger-unbind": function triggerUnbind($event) {
        return _vm.showUnbindStaff();
      },
      "trigger-change-bound-type": function triggerChangeBoundType($event) {
        return _vm.showChangeBoundType();
      }
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 row d-flex mb-4 mb-xl-2 justify-content-between flex-row-reverse"
  }, [_c('div', {
    staticClass: "\n          col-12 col-xl-4 col-start-12\n          xl:col-start-1\n          d-flex\n          flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.CUSTOMER_STAFF_BIND_STAFF]) ? _c('span', {
    staticClass: "d-inline-block mr-2",
    attrs: {
      "id": "btn-bind-current-staff-wrapper"
    }
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0",
    style: _vm.isCurrentStaffBound ? 'pointer-events: none;' : '',
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.isCurrentStaffBound
    },
    on: {
      "click": _vm.showBindCurrentStaff
    }
  }, [_c('i', {
    staticClass: "mdi mdi-account-network"
  }), _vm._v("立即綁定此客戶 ")])], 1) : _vm._e(), _vm.checkPermission([_vm.consts.CUSTOMER_STAFF_BIND_STAFF]) && _vm.isCurrentStaffBound ? _c('b-tooltip', {
    attrs: {
      "target": "btn-bind-current-staff-wrapper",
      "triggers": "hover"
    }
  }, [_vm._v(" 您目前已經綁定此會員 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.CUSTOMER_STAFF_BIND_STAFF]) ? _c('CustomerAddStaff', {
    attrs: {
      "customer": _vm.customer
    },
    on: {
      "added": function added($event) {
        return _vm.getCustomerStaffs();
      }
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customerStaffs,
      "fields": _vm.fields,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "busy": _vm.showLoading
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.sortDesc = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "head(id)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.handleSelectAll
          },
          model: {
            value: _vm.isSelectAll,
            callback: function callback($$v) {
              _vm.isSelectAll = $$v;
            },
            expression: "isSelectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(id)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": data.item.pivot_id,
            "disabled": !_vm.doesBound
          },
          on: {
            "change": _vm.handleChecboxChange
          },
          model: {
            value: _vm.selectedPivotIds,
            callback: function callback($$v) {
              _vm.selectedPivotIds = $$v;
            },
            expression: "selectedPivotIds"
          }
        })];
      }
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)];
      }
    }, {
      key: "cell(bound_type)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.mapBoundTypeName(data.item.bound_type)) + " ")];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }